//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {mapState} from 'vuex'
export default{
    props: ['show'],
    data(){
        return{
            checked: false,
            guiNumber: '',
            internalShow:this.show
        }
    },
    computed:{
      ...mapState([
        'global'
      ]),
    },
    watch: {
      show(val) {
        this.internalShow = val;
      },
      internalShow(val){
        if(val==false){
          this.$emit('close')
        }
      }
    },
    methods: {
        onClose(){
            this.$emit('close')
        },
        onConfirm(){
            const guiNumber = this.guiNumber
            console.log(guiNumber, guiNumber.length)
            if(this.checked === 'B2B'){
                const pattern = /^\/[0-9A-Z.\-+]{7}$/
                if(!guiNumber){
                    return this.$message("請輸入載具條碼(格式範例/ABCD123)")
                }
                if(!pattern.test(guiNumber)){
                    return this.$message("總長度為8碼字元，第一碼必為「/」，其餘7碼由數字0～9、大寫英文A～Z與特殊符號「.」、「-」、「+」組成。")
                }
            }
            this.$emit('confirm', this.guiNumber)
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/cart/modal/GUINumber.vue